import DisplayPrice from "components/common/DisplayPrice";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { StatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAddonDetails } from "store/slices/membershipSlice";
import { PLAN_OPTIONS } from "utils/constants";
import PageHeader from "components/common/PageHeader";

const AddonDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");
  const { canAction } = usePermission();
  const { canView } = canAction("membership_addon");
  const { loading, addonDetails } = useSelector((state) => state.Membership);

  useEffect(() => {
    if (id && canView) {
      dispatch(getAddonDetails(id));
    }
  }, [id, canView]);

  const {
    title,
    description,
    status,
    allowedFor,
    isUnlimited,
    maxUses,
    price,
  } = addonDetails;

  if (!canView) return null;

  if (loading) {
    return (
      <div className="page-content">
        <PageHeader
          title={t("Add Ons Details")}
          isBackBtn
          className="details_page_title"
        />
        <div className="common_card">
          <DetailsShimmer />
        </div>
      </div>
    );
  }

  return (
    <div className="page-content common_details_page">
      <PageHeader
        title={t("Add Ons Details")}
        isBackBtn
        className="details_page_title"
      />
      <div className="common_card">
        <Row className="details_page_item_row">
          <Col lg={3} xs={6} md={3}>
            <h6 className="label">{t("Add On Name")}</h6>
            <h6 className="title">{title?.en}</h6>
          </Col>
          <Col lg={3} xs={6} md={3}>
            <h6 className="label">{t("Allowed For")}</h6>
            <h6 className="value">
              {allowedFor
                ?.map(
                  (item) => {
                    const option = PLAN_OPTIONS.find(
                      (opt) => opt.value === item,
                    );
                    return option?.name ? t(option.name) : null;
                  }
                )
                .filter(Boolean)
                .join(", ")}
            </h6>
          </Col>
          <Col lg={3} xs={6} md={3}>
            <h6 className="label">{t("Price")}</h6>
            <h6 className="value">
              <DisplayPrice value={price} width="12" height="15" />
            </h6>
          </Col>
          <Col lg={3} xs={6} md={3}>
            <h6 className="label">{t("Status")}</h6>
            <StatusBadge status={status} t={t} />
          </Col>
          <Col lg={3} xs={6} md={3} className="mt-2">
            <h6 className="label">{t("Unlimited")}</h6>
            <h6 className="value">{isUnlimited ? t("Yes") : t("No")}</h6>
          </Col>
          {!isUnlimited && (
            <Col lg={3} xs={6} md={3} className="mt-2">
              <h6 className="label">{t("Max Usage")}</h6>
              <h6 className="value">{maxUses}</h6>
            </Col>
          )}
        </Row>

        <Row className="mt-4">
          <Col lg={12}>
            <h6 className="label">{t("Description")}</h6>
            <h6 className="value">{description?.en || "-"}</h6>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AddonDetails;
